package org.vreo.devicehub.features.deviceDetails.presentation

import org.vreo.devicehub.features.core.domain.device.device.ProductType
import org.vreo.devicehub.features.core.presentation.UiText

/**
 * Device details screen state. Holds UI-ready data derived from an AnprDevice, the view never
 * accesses the domain model directly.
 *
 * @property isLoading whether device details are being loaded
 * @property error error to present
 * @property isDeviceActive device connection status
 * @property deviceId device id provided by data source
 * @property productType localized device product type/model name
 * @property serialNumber device serial number
 * @property softwareVersion device software version
 * @property ocrVersion device OCR version
 * @property localIpAddress device local network ip address
 * @property macAddress device MAC address
 * @property lastActivityTime formatted last activity date and time, null if never active
 * @property userTag user assigned device name/tag
 * @property linkingPassword device linking password, null if not set
 */
data class DeviceDetailsState(
    // General device data
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val isDeviceActive: Boolean = false,
    val deviceId: String = "",
    val productType: ProductType? = null,
    val serialNumber: String = "",
    val softwareVersion: String = "",
    val ocrVersion: String = "",
    val localIpAddress: String = "",
    val macAddress: String = "",
    val lastActivityTime: String? = null,
    val userTag: String? = null,
    val linkingPassword: String? = null,

    // Tag update control
    val temporarilyTag: String = "",
    val editingTag: Boolean = false,

    // Management
    val showUnlinkDialog: Boolean = false,
    val showDeleteDialog: Boolean = false,
)